import React from 'react';
import { Text } from '@cotera/client/app/components/ui';
import { cn } from '@cotera/client/v0/lib/utils';

/** Matches {@link Canvas} / React Flow dot background (gap 20, 1px dots). */
const WORKFLOW_CANVAS_DOT_GRID_CLASS =
  'bg-sidebar [background-image:radial-gradient(#91919a_0.5px,transparent_0.5px)] [background-size:20px_20px] dark:[background-image:radial-gradient(#777_0.5px,transparent_0.5px)]';

type WorkflowEditorLoadingProps = {
  message?: string;
  className?: string;
};

export const WorkflowEditorLoading: React.FC<WorkflowEditorLoadingProps> = ({
  message = 'Loading workflow…',
  className,
}) => (
  <div
    className={cn(
      'flex h-full w-full items-center justify-center overflow-hidden',
      WORKFLOW_CANVAS_DOT_GRID_CLASS,
      className
    )}
  >
    <Text.P className="text-muted-foreground">{message}</Text.P>
  </div>
);
